<template>
  <b-modal
    ref="add-bonus-modal"
    hide-footer
    no-close-on-backdrop
    @hidden="onlyClose"
    :title="modalTitle"
  >
    <template #default>
      <validation-observer ref="form">
        <b-row>
          <b-col lg="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group
                :label="$t('Type')"
                :state="errors[0] ? false : null"
              >
                <v-select
                  v-model="bonus.type"
                  :reduce="(value) => value.id"
                  label="label"
                  :options="bonusTypes"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group :label="$t('Name')">
                <b-form-input
                  v-model="bonus.name"
                  :class="{ 'border-danger': errors[0] }"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group
                :label="$t('Amount')"
                :state="errors[0] ? false : null"
              >
                <money
                  class="form-control form-control-md"
                  v-model="bonus.amount"
                  v-bind="amountConfig"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end" style="width: 100%">
          <b-button variant="outline-danger" size="sm" @click="onlyClose">
            {{ $t("close") | capitalize }}
          </b-button>
          <b-button variant="outline-primary" class="ml-1" @click="submitForm">
            {{ method == "create" ? $t("save") : $t("edit") | capitalize }}
          </b-button>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
import SettingsBonusService from "@/views/settings/views/payroll/components/bonus/service/setting-bonus.service.js";
import { mapGetters } from "vuex";

export default {
  props: {
    bonus: {
      type: Object,
      required: false,
    },
    method: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    modalTitle() {
      return this.method == "create"
        ? this.$t("Add Bonus")
        : this.$t("Edit Bonus");
    },

    // prefix() {
    //   return this.userData.currency === 1
    //     ? "$"
    //     : this.userData.currency === 2
    //     ? "S/."
    //     : "$";
    // },
  },
  data() {
    return {
      amountConfig: {
        decimal: ".",
        thousands: ",",
        prefix: "S/.",
        precision: 2,
        masked: false,
      },
      bonusTypes: [
        {
          id: "1",
          label: this.$t("Employee"),
        },
        {
          id: "2",
          label: this.$t("Driver"),
        },
        {
          id: "3",
          label: this.$t("All"),
        },
      ],
      //   laborRegime: this.labor ? Object.assign({}, this.labor) : null,
    };
  },
  mounted() {
    this.toggleModal("add-bonus-modal");
  },

  methods: {
    onlyClose() {
      this.$emit("onlyClose");
    },
    closeRefresh() {
      this.$emit("closeReload");
    },

    async submitForm() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        try {
          this.addPreloader();
          const params = {
            type: this.bonus.type,
            created_by: this.currentUser.id,
            name: this.bonus.name,
            amount: this.bonus.amount,
            status: this.method === "create" ? 1 : this.bonus.status,
            method: this.method,
          };
          const { data } = await SettingsBonusService.createOrUpdate(params);
          this.showToastSuccess(data.message);
          this.$emit("closeReload");
        } catch (error) {
          if (error && "response") {
            let { status, data } = error.response;
            if (status === 422) {
              let keys = Object.keys(data.errors);
              keys.forEach((key) => {
                this.showToastError(data.errors[key][0], data.message);
              });
            }
          } else {
            this.showToastError(error);
          }

          console.log(error);
        } finally {
          this.closeRefresh();
          this.removePreloader();
        }
      }
    },
  },
};
</script>

<style>
</style>